import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReservationNotification from 'components/components/common/ReservationNotification';
import NotificationButtons from './NotificationButtons';
import FlightDetailsContainer from './FlightDetailsContainer';
import PropTypes from 'prop-types';
import { setReservationToReview } from 'components/actions/serviceActions';

const propTypes = {
  reservation: PropTypes.object,
};

class ReservationItem extends Component {

  render() {
    return (
      <div>
        <div className="nav-bottom">
          <div className="nav-bottom__content dashboard-summary">
            <div className="grid__item">
              <FlightDetailsContainer
                locale={this.props.locale}
                {...this.props.reservation}
              />
              <ReservationNotification
                avatar={false}
                busArrival={this.props.reservation.bus_arrival}
                cancelledWithRefund={this.props.reservation.cancelled_with_refund}
                driverName={this.props.reservation.driver_name}
                driverPhone={this.props.reservation.driver_phone}
                locale={this.props.locale}
                notificationDate={this.props.reservation.notification_date}
                paymentToDriver={this.props.reservation.payment_to_driver}
                reservation={this.props.reservation}
                setReservationToReview={this.props.setReservationToReview}
                status={this.props.reservation.status}
                type={this.props.reservation.flight_type}
              />
              <NotificationButtons
                locale={this.props.locale}
                reservation={this.props.reservation}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isLogged: state.app.isLogged,
    locale: state.app.locale
  }
}

ReservationItem.propTypes = propTypes;

export default connect(mapStateToProps, { setReservationToReview })(ReservationItem);
